import { httpService } from '../helper';
import { constants } from '../constants';

export const getApplicationStatus = httpService().get.bind(this, constants.API.APPLICATION_STATUS);
export const getPendingDocList = httpService().get.bind(this, constants.API.GET_PENDING_DOCUMENT_LIST);
export const postPendingDocList = (formData) =>
  httpService(formData).post.call(null, constants.API.POST_PENDING_DOCUMENT_LIST, formData);
export const postFeedBackForm = (formData) =>
  httpService(formData).post.call(null, constants.API.POST_FEEDBACK_FORM, formData);
